/* eslint-disable css-modules/no-unused-class  */
import TournamentBanner from '@components/tournament/tournamentBanner';
import { selectLocale } from '@redux/slices/userSlice';
import { tournamentServer } from 'network-utils';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import LearningPathBanner, {
    LearningPathBannerProps
} from '@components/learningPath/learningPathBanner/learningPathBanner';
import SkillTreeBanner, { SkillTreeBannerProps } from '@components/skillTree/skillTreeBanner/skillTreeBanner';
import { Divider } from 'learning-panel-components';
import VideoTutorialBanner, {
    VideoTutorialBannerProps
} from '@components/home/homeTabs/videoTutorialsPage/videoTutorialsBanner/videoTutorialsBanner';
import { CourseBannerProps } from '@components/learn/courseBanner/courseBannerTypes';
import CourseBanner from '@components/learn/courseBanner/courseBanner';
import LessonBanner, { LessonBannerProps } from '@components/learn/lessonBanner/lessonBanner';
import LabBanner, { LabBannerProps } from '@components/learn/labBanner/labBanner';
import AssessmentBanner, { AssessmentBannerProps } from '../banner/assessmentBanner';
import Gallery from '../gallery';
import styles from './homePageBanners.module.scss';

const HomePageBanners: FC<{
    assessments: AssessmentBannerProps[];
    upComingTournaments: tournamentServer.UpComingTournament[];
    learningPaths: LearningPathBannerProps[];
    skillTreeBanner: SkillTreeBannerProps[];
    videoTutorialsBanner: VideoTutorialBannerProps[];
    courseBanner: CourseBannerProps[];
    lessonsBanner: LessonBannerProps[];
    labBanner: LabBannerProps[];
    showDivider?: boolean;
}> = ({
    assessments,
    upComingTournaments,
    learningPaths,
    skillTreeBanner,
    videoTutorialsBanner,
    courseBanner,
    lessonsBanner,
    labBanner,
    showDivider = true
}: {
    assessments: AssessmentBannerProps[];
    upComingTournaments: tournamentServer.UpComingTournament[];
    learningPaths: LearningPathBannerProps[];
    skillTreeBanner: SkillTreeBannerProps[];
    videoTutorialsBanner: VideoTutorialBannerProps[];
    courseBanner: CourseBannerProps[];
    lessonsBanner: LessonBannerProps[];
    labBanner: LabBannerProps[];
    showDivider?: boolean;
}) => {
    const locale = useSelector(selectLocale);

    const getBanners = () => {
        const assessmentsBanners = assessments.map((assessment, i) => <AssessmentBanner {...assessment} key={i} />);
        const tournamentsBanners = upComingTournaments.map((tournament, i) => (
            <TournamentBanner locale={locale} {...tournament} key={i} />
        ));
        const courseBanners = courseBanner.map((course, i) => <CourseBanner {...course} key={i} />);
        const lessonsBanners = lessonsBanner.map((lesson, i) => <LessonBanner {...lesson} key={i} />);
        const skillTreeBanners = skillTreeBanner.map((skillTree, i) => <SkillTreeBanner {...skillTree} key={i} />);
        const learningPathsBanners = learningPaths.map((learningPath, i) => (
            <LearningPathBanner {...learningPath} key={i} />
        ));
        const videoTutorialsBanners = videoTutorialsBanner.map((videoTutorial, i) => (
            <VideoTutorialBanner {...videoTutorial} key={i} />
        ));
        const labBanners = labBanner.map((lab, i) => <LabBanner {...lab} key={i} />);

        return [
            ...assessmentsBanners,
            ...tournamentsBanners,
            ...courseBanners,
            ...lessonsBanners,
            ...skillTreeBanners,
            ...learningPathsBanners,
            ...videoTutorialsBanners,
            ...labBanners
        ];
    };

    const banners = getBanners();
    console.log(banners);
    return (
        <>
            <div className={styles['section-gallery']}>
                {banners.length > 1 ? (
                    <Gallery elementWidth="30rem" numberOfElements={banners.length}>
                        {banners}
                    </Gallery>
                ) : (
                    <>
                        {assessments.length === 1 ? <AssessmentBanner {...assessments[0]} key={1} /> : null}
                        {upComingTournaments.length === 1 ? (
                            <TournamentBanner locale={locale} {...upComingTournaments[0]} key={1} />
                        ) : null}
                        {courseBanner.length === 1 && <CourseBanner {...courseBanner[0]} key={1} />}
                        {lessonsBanner.length === 1 && <LessonBanner {...lessonsBanner[0]} key={1} />}
                        {learningPaths.length === 1 && <LearningPathBanner {...learningPaths[0]} key={1} />}
                        {skillTreeBanner.length === 1 && <SkillTreeBanner {...skillTreeBanner[0]} key={1} />}
                        {videoTutorialsBanner.length === 1 && (
                            <VideoTutorialBanner {...videoTutorialsBanner[0]} key={1} />
                        )}
                        {labBanner.length === 1 && <LabBanner {...labBanner[0]} key={1} />}
                    </>
                )}
            </div>
            {showDivider && banners && banners.length > 0 && (
                <Divider
                    className={styles['performance-divider']}
                    orientation="horizontal"
                    color="rgba(255, 255, 255, 0.2)"
                />
            )}
        </>
    );
};

export default HomePageBanners;
